import logger from "@Utils/Logger";
import AppLayout from "@wff/components/layout/AppLayout";
import { useBreadcrumb } from "@wff/hooks/useBreadcrumb";
import componentMapping from "../ComponentMapping";
import { getCmsPageBySlug } from "../Contentful.helper";

interface cmsPageProps {
  children?: React.ReactNode;
  pageModel: any;
  pageTitle?: string;
  productSKU?: string;
  pageDescription?: string;
}

interface pageModelTypes {
  locale?: string;
  slug?: string;
  productId?: string;
  resourceName?: string;
}

interface getCMSPageModelOptions {
  keepOriginalSlug?: boolean;
}

/**
 * Component - CMS Page
 * @returns
 */
const CmsPage = (props: cmsPageProps) => {
  const {
    pageModel,
    pageTitle = "",
    productSKU,
    pageDescription = "",
    children,
  } = props;
  const contents = pageModel?.pageContent?.templates?.items ?? [];

  let templates;
  if (contents.length > 0) {
    let Comp;
    templates = contents.map((content: any, index: number) => {
      const contentKey = content?.content_type;
      // eslint-disable-next-line security/detect-object-injection
      Comp = componentMapping[contentKey];
      if (Comp) {
        return <Comp key={`${contentKey}_${index}`} {...content}></Comp>;
      } else {
        return null;
      }
    });
  }
  // set the Root label for Breadcrumbs in all pages
  useBreadcrumb({
    homeSlug: {
      title: pageModel?.siteGlobal?.homeSlugLabel
        ? pageModel?.siteGlobal?.homeSlugLabel
        : "Home",
      link: "/",
    },
  });

  return (
    <>
      <AppLayout
        pageTitle={pageTitle}
        productSKU={productSKU}
        pageDescription={pageDescription}
        pageModel={pageModel}
      >
        {templates}
        {children}
      </AppLayout>
    </>
  );
};

export const getCMSPageModel = async (
  query: string,
  payload: pageModelTypes,
  options?: getCMSPageModelOptions
) => {
  const { locale = "en-US", slug } = payload;
  const { keepOriginalSlug = false } = options || {};
  let slugStr = slug;

  const country = (locale.split("-")?.[1] ?? "us").toLocaleLowerCase();

  if (slug && !keepOriginalSlug) {
    slugStr = `wildfork-${country}-${slug}`;
  }

  const reqPayload = {
    ...payload,
    slug: slugStr,
    country,
  };

  logger.info("CmsPage.tsx getCMSPageModel()", payload);

  return await getCmsPageBySlug(query, reqPayload);
};

export default CmsPage;
